import type { Group } from '@/modules/programs/engine/programs.types';

export const GROUPS: Group[] = [
	{
		name: 'General',
		description:
			'This is the general group for people in this organization',
		peopleCount: 20,
	},
	{
		name: 'Product Team',
		description: 'Design, BAs, and QAs',
		peopleCount: 5,
	},
];
